import { render } from "./NewStory.vue?vue&type=template&id=432d9b86&scoped=true"
import script from "./NewStory.vue?vue&type=script&lang=js"
export * from "./NewStory.vue?vue&type=script&lang=js"

import "./NewStory.vue?vue&type=style&index=0&id=432d9b86&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-432d9b86"]])

export default __exports__